module.exports = __webpack_public_path__ + "img/43.c9a3f074.png";